/**
 * Matches optional \r + \n globally (handles Unix \n, Windows \r\n, old Mac \r).
 */
const NEWLINE_REGEX = /\r?\n?/gu;

/**
 * Flattens a multiline string into a single line by removing all newline characters.
 * @param str - The input string that may contain newlines.
 * @returns The input string with all newlines removed.
 */
export function flattenString(str: string): string {
	return str.replace(NEWLINE_REGEX, "");
}
